// src/hooks/useProductsCrud.js

import { useState, useEffect } from "react";
import productService from "../services/productService";
import authService from "../services/authService";
import { useNavigate } from "react-router-dom";

export const useProductsCrud = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (!authService.isLoggedIn()) {
      setErrors({ auth: "User not authenticated" });
      setLoading(false);
      navigate("/login");
      return;
    }
    fetchAllProducts();
  }, [navigate]);

  const fetchAllProducts = async () => {
    setLoading(true);
    try {
      const res = await productService.getAllProducts();
      setProducts(res.data?.data || res.data);
      setErrors({});
    } catch (error) {
      console.error("Fetch error:", error);
      setErrors({ fetch: error.message || "Failed to fetch products" });

      if (error.response?.status === 401) {
        authService.logout();
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchProduct = async (id) => {
    try {
      const res = await productService.getProductById(id);
      return res.data?.data || res.data;
    } catch (error) {
      console.error("Fetch product error:", error);
      setErrors({ general: error.message || "Failed to fetch product" });
      throw error;
    }
  };

  const createProduct = async (item) => {
    try {
      const res =
        item.thumb_image instanceof File
          ? await productService.createProductWithFile(item)
          : await productService.createProduct(item);

      fetchAllProducts();
      return res.data;
    } catch (error) {
      console.error("Create error:", error.response?.data || error.message);
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors || { general: "Validation failed" });
      } else {
        setErrors({ general: error.message || "Create failed" });
      }
      throw error;
    }
  };

const updateProduct = async (id, item) => {
  try {
    let payload = { ...item };

    // If thumb_image is NOT a File, remove it
    if (!(item.thumb_image instanceof File)) {
      delete payload.thumb_image;
    }

    const res = await productService.updateProductWithFile(id, payload);

    fetchAllProducts();
    return res.data;

  } catch (error) {
    console.error("Update error:", error.response?.data || error.message);

    if (error.response?.status === 422) {
      setErrors(error.response.data.errors || { general: "Validation failed" });
    } else {
      setErrors({ general: error.message || "Update failed" });
    }

    throw error;
  }
};


//   const updateProduct = async (id, item) => {
//   try {
//     const formData = new FormData();

//     Object.keys(item).forEach((key) => {
//       if (key === "thumb_image") {
//         if (item.thumb_image instanceof File) {
//           formData.append("thumb_image", item.thumb_image);
//         }
//       } else {
//         formData.append(key, item[key] ?? "");
//       }
//     });

//     const res = await productService.updateProductWithFile(id, formData);

//     fetchAllProducts();
//     return res.data;
//   } catch (error) {
//     console.error("Update error:", error.response?.data || error.message);
//     if (error.response?.status === 422) {
//       setErrors(error.response.data.errors || { general: "Validation failed" });
//     } else {
//       setErrors({ general: error.message || "Update failed" });
//     }
//     throw error;
//   }
// };


  const deleteProduct = async (id) => {
    try {
      await productService.deleteProduct(id);
      fetchAllProducts();
    } catch (error) {
      console.error("Delete error:", error);
      setErrors({ general: error.message || "Delete failed" });
    }
  };

  return {
    products,
    setProducts,
    loading,
    errors,
    fetchAllProducts,
    fetchProduct,
    createProduct,
    updateProduct,
    deleteProduct,
  };
};
